<template>
    <modal-dialog
        id="comments"
        :show.sync="shown"
    >
        <template v-slot:title>
            {{ title }}
            <base-button
                size="large"
                flavor="link"
                @click.native.prevent="copy"
            >
                <open-icon glyph="clipboard" />
            </base-button>
        </template>

        <comments
            :owner-id="ownerId || 0"
            :owner-type="ownerType"
            :sourced-comments="comments"
            :editable="editable"
        />

        <div class="uk-modal-footer uk-text-center">
            <base-button size="large" :block="true" @click.native.prevent="close">Done</base-button>
        </div>
    </modal-dialog>
</template>

<script type="text/javascript">
// import { orderBy } from 'lodash'

import ModalDialog from "./ModalDialog/ModalDialog"
import BaseButton from "../ui/BaseButton"
import Comments from "../ui/Comments"
import OpenIcon from "../ui/OpenIcon"

export default {
    components: {
        ModalDialog,
        BaseButton,
        Comments,
        OpenIcon
    },
    methods: {
        copy () {
            const lines = []
            this.comments.forEach(comment => {
                lines.push(comment.content)
            })
            this.$clipboard(lines.join("\r\n==========\r\n"))
            this.$success("Comments copied to clipboard!")
        },
        close () {
            this.$emit("update:show", false)
        }
    },
    computed: {
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        comments: {
            type: Array,
            required: true
        },
        ownerId: {
            type: Number,
            required: true
        },
        ownerType: {
            type: String,
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
        }
    }
}
</script>
